/**
 * ページビュービーコン
 *
 * ScrollToTop と同様に BrowserRouter 直下にマウントする null コンポーネント。
 * ルート遷移ごとに /api/public/pv へ PV を送信する。
 * - dev では送信しない（データ汚染防止）
 * - /admin 配下は記録しない
 * - リファラはタブごとに初回遷移のみ送信（流入元計測）
 * - StrictMode の二重実行は直前パスの記録でガード
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendPageView } from '@/services/pageView';

const REFERRER_SENT_KEY = 'kg_pv_ref_sent';

export default function PageViewBeacon() {
  const { pathname } = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (import.meta.env.DEV) return;
    if (pathname.startsWith('/admin')) return;
    if (lastPathRef.current === pathname) return;
    lastPathRef.current = pathname;

    let referrer: string | undefined;
    let utmSource: string | undefined;
    let landing = false;
    try {
      if (!sessionStorage.getItem(REFERRER_SENT_KEY)) {
        sessionStorage.setItem(REFERRER_SENT_KEY, '1');
        landing = true; // タブ初回 = ランディング（流入元×着地ページの記録用）
        referrer = document.referrer || undefined;
        // noreferrer リンク経由でも流入元を計測できるよう utm_source を拾う
        utmSource =
          new URLSearchParams(window.location.search).get('utm_source') ??
          undefined;
      }
    } catch {
      // sessionStorage が使えない環境（プライベートモード等）はリファラなしで送信
    }

    sendPageView({ path: pathname, referrer, utmSource, landing });
  }, [pathname]);

  return null;
}
